export const SHOW_PAGE = '[PAGE APP] SHOW PAGE';
export const SET_ONE_COLUMN_LAYOUT = '[PAGE APP] SET ONE COLUMN LAYOUT';
export const UNSET_ONE_COLUMN_LAYOUT = '[PAGE APP] UNSET ONE COLUMN LAYOUT';
export const SHOW_CART_BUTTON = '[PAGE APP] SHOW CART BUTTON';
export const HIDE_CART_BUTTON = '[PAGE APP] HIDE CART BUTTON';
export const SET_PREVIOUS_HISTORY = '[PAGE APP] SET PREV HISTORY';

export const pages = {
    restaurant: 'restaurant',
    checkout: 'checkout',
    checkoutSummary: 'checkout-summary',
    checkoutSummaryUpdated: 'checkout-summary-updated',
    subscribe: 'subscribe',
    unsubscribe: 'unsubscribe',
    unsubscribed: 'unsubscribed',
    cart: 'cart',
    gift: 'gift',
    registration: 'registration',
    registrationConfirm: 'registration-confirm',
    login: 'login',
    forgot: 'forgot',
    customer: 'customer',
};

export function showPage(name) {
    return {
        type: SHOW_PAGE,
        page: name
    };
}

export function setOneColumn() {
    return {
        type: SET_ONE_COLUMN_LAYOUT,
    };
}

export function unsetOneColumn() {
    return {
        type: UNSET_ONE_COLUMN_LAYOUT,
    };
}

export function showCartButton() {
    return {
        type: SHOW_CART_BUTTON,
    };
}

export function hideCartButton() {
    return {
        type: HIDE_CART_BUTTON,
    };
}

export function setPreviousHistory(url, pageName) {
    return {
        type: SET_PREVIOUS_HISTORY,
        payload: {url, pageName}
    };
}
